import { render, staticRenderFns } from "./shareQr.vue?vue&type=template&id=21adaf1c&scoped=true"
import script from "./shareQr.vue?vue&type=script&lang=js"
export * from "./shareQr.vue?vue&type=script&lang=js"
import style0 from "./shareQr.vue?vue&type=style&index=0&id=21adaf1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adaf1c",
  null
  
)

export default component.exports